
import { combineReducers } from 'redux';
import { IEntityActions } from '../../../../../../data/store';
import { SaveState } from '../../../../../../types';

export const submitOverridesSaveState = (state: SaveState = SaveState.NONE, action: IEntityActions = {} as any) => {
	switch (action.type) {
		case 'BOOKING_STATE_SUBMIT_OVERRIDES_REQUEST':
			return SaveState.PENDING;
		case 'BOOKING_STATE_SUBMIT_OVERRIDES_RECEIVE':
			return SaveState.SUCCESS;
		case 'BOOKING_STATE_SUBMIT_OVERRIDES_FAILURE':
			return SaveState.FAILURE;
		default:
			return state;
	}
};

interface IOverrideSubmissionState {
	submitOverridesSaveState: ReturnType<typeof submitOverridesSaveState>;
}

export default combineReducers<IOverrideSubmissionState>({
	submitOverridesSaveState
});
